"use strict";

exports.__esModule = true;
exports.useRandomIdSeed = exports.default = void 0;
var _reactUid = require("react-uid");
const useRandomIdSeed = () => {
  return (0, _reactUid.useUIDSeed)();
};
exports.useRandomIdSeed = useRandomIdSeed;
const useRandomId = () => {
  return (0, _reactUid.useUID)();
};
var _default = useRandomId;
exports.default = _default;